import { FB_EVENTS, sendFBEvent } from 'commons/fbEvents';
import { logError } from 'commons/logger';
import { useEffect } from 'react';
import useMetaFormattedCityStateZip from '../useMetaFormattedCityStateZip';

const DEFAULT_BASIC_DETAILS = {};
const DEFAULT_VARIANT_SKU = '';

const useJbEventFBAddToCart = ({
  basicDetails = DEFAULT_BASIC_DETAILS,
  selectedOptionsVariantSku = DEFAULT_VARIANT_SKU,
}) => {
  const {
    formattedZip: zip,
    formattedCity: city,
    formattedState: state,
  } = useMetaFormattedCityStateZip();

  useEffect(() => {
    const sku = basicDetails?.sku
      ? basicDetails.sku + selectedOptionsVariantSku
      : null;

    window.jbEventFBAddToCart = () => {
      if (basicDetails?.sku) {
        sendFBEvent(FB_EVENTS.ADD_TO_CART, {
          content_category: basicDetails.productType,
          content_ids: [sku],
          content_name: basicDetails.productName,
          content_type: 'product',
          currency: 'USD',
          value: basicDetails.value,
          zp: zip,
          ct: city,
          st: state,
        });
      } else {
        logError(new Error('window.jbEventFBAddToCart: missing sku'));
      }
    };
  }, [
    basicDetails?.sku,
    basicDetails.productType,
    basicDetails.productName,
    basicDetails.value,
    city,
    selectedOptionsVariantSku,
    state,
    zip,
  ]);
};

export default useJbEventFBAddToCart;
